
/*
    Handles laying out the main non-banner page content vertically
    - we either have just that content on its own
    - or else that content + a subnav bar

    Tablet vs laptop layouts are distinguished here, and 2vh of margin 
    are incorporated except for when there's a subnav in laptop view
*/

import React from "react";
import Media from "react-media";

import Constants from "../Constants";

const VerticalLayout = (props) => {

    const remainder = 100 - Constants.BANNER_HEIGHT_VH;
    const first = props.firstHeight;
    const second = remainder - first;

    let style = null;
    let tabletStyle = null;

    if(first){
        style = {
            display: "grid",
            gridTemplateRows: `${first}vh ${second}vh`
        };

        tabletStyle = {
            display: "grid",
            gridTemplateRows: `${first-2}vh ${second+2}vh`
        };
    }
    else{
        style = {
            marginTop: "2vh",
            height: `${second - 2}vh`
        };

        tabletStyle = style;
    }

    return (
        <>
        <Media query="(max-width: 811px)">
            <div style={tabletStyle}>
                {props.children}
            </div>
        </Media>
        <Media query="(min-width: 812px)">
            <div style={style}>
                {props.children}
            </div>
        </Media>
        </>
    )
}

export default VerticalLayout;